// extracted by mini-css-extract-plugin
export default {"fakeSelectWrapper":"SearchSelect_fakeSelectWrapper__8v-lc"};